import { PrepareBodyProps } from '../interfaces';

export const prepareBody = <TBody>({ body }: PrepareBodyProps<TBody>) => {
  if (body instanceof FormData) return body;
  if (typeof body === 'object') return JSON.stringify(body);

  return undefined;
};
